module.exports = __webpack_public_path__ + "static/media/gallery-12.5e398a42.jpg";